import React, { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { useNavigate } from "react-router-dom";
import { useGetPatientQuery } from "@store/patientApi";
import Loader from "@components/Loader/Loader";
import OnboardingCompanionForm from "@components/Onboarding/OnboardingCompanionForm";

const OnboardingCompanion: FC<{ isPatient: boolean }> = ({
  isPatient = true,
}) => {
  const patientId = useSelector(
    (state: RootState) => state.home.selectedPatientId,
  );
  const accountId = useSelector((state: RootState) => state.account.accountId);
  const navigate = useNavigate();
  const { data: patient, isLoading } = useGetPatientQuery(patientId!, {
    skip: !patientId,
  });

  useEffect(() => {
    if (!accountId) {
      navigate("/onboarding");
    } else if (!patient && !isLoading) {
      navigate("/onboarding/profile");
    }
  }, [patient, navigate, accountId, isLoading]);

  return (
    <>
      {isLoading || !patient ? (
        <Loader />
      ) : (
        <OnboardingCompanionForm patient={patient} isPatient={isPatient} />
      )}
    </>
  );
};

export default OnboardingCompanion;
